import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../api.service';
import { CookieService } from 'ngx-cookie-service'; // Import the CookieService
import { HttpResponse } from '@angular/common/http';
import { CommonService } from "../../shared/common.service";
import { SocketService } from "../../socket.service";
import { Socket } from 'socket.io-client';
import { InactivityLogoutService } from "../../shared/inactivity-logout.service";

@Component({
  selector: 'app-email-login',
  templateUrl: './email-login.component.html',
  styleUrls: ['./email-login.component.scss']
})
export class EmailLoginComponent {

  form: FormGroup;
  showOtpForm = false;
  verifyOtp = false;
  message: string;
  email: string;
  otp: string;
  otpStatus: string;
  generatedOtp: string | null = null;
  token: string | null = null;
  isResendVisible: boolean = false;
  timer: any;
  showResendButton: boolean;
  canResendOtp = false;
  resendTimer: any;
  resendTimeout = 60;
  otpSentTime: number | null = null;

  resendTimeoutDuration = 60000; // 60 seconds 

  data  : string;

  loginSubmitted = false;
  registerSubmitted = false;


  constructor(private fb: FormBuilder, private router: Router,
    private http: HttpClient, private apiService: ApiService,
    private socketService: SocketService,
    private cookieService: CookieService,
    private commonService: CommonService,
    private inactivityService: InactivityLogoutService
  ) {
    this.form = this.fb.group({
      Email: ['', [Validators.required, Validators.email]],
      Password: ['', [Validators.required, this.passwordValidator]],
      NewPassword: ['', [Validators.required, this.passwordValidator]],
      OTP: [''],
       FirstName: ['', Validators.required], // for register
       LastName: ['', Validators.required],   // for register
      Terms: [false, Validators.requiredTrue] // for register checkbox
    });
  }

  // Custom password validator
  passwordValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Don't validate empty values (handled by required validator)
    }

    const password = control.value;
    const errors: any = {};

    // Check minimum length
    if (password.length < 8) {
      errors.minLength = true;
    }

    // Check for at least one capital letter
    if (!/[A-Z]/.test(password)) {
      errors.noCapital = true;
    }

    // Check for at least one small letter
    if (!/[a-z]/.test(password)) {
      errors.noSmall = true;
    }

    // Check for at least one number
    if (!/[0-9]/.test(password)) {
      errors.noNumber = true;
    }

    // Check for at least one special character
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
      errors.noSpecial = true;
    }

    return Object.keys(errors).length > 0 ? errors : null;
  }

  // Helpers to validate only specific control groups (login/register separable)
  private areControlsValid(controlNames: string[]): boolean {
    return controlNames.every(name => this.form.get(name)?.valid);
  }

  onRequestOtp(): void {
    const email = this.form.get('Email')?.value;
    if (SocketService.socketId) {
      this.socketService.onOtpStatus((data) => {
        if (data.email === email) {
          this.otpStatus = data.status;
          console.log(`[OTP Status] ${data.status}`)

          if (data.status === "Sending Email") {
            // this.message = "Sending Email";
            this.showOtpForm = true;
            this.verifyOtp  = true;
            this.canResendOtp = false;
          }

          if (data.status === "OTP sent successfully") {
            this.message = 'OTP send sucessfully';
            this.startResendTimer();
          }
        }
      })
      this.socketService.emitRequestOtp(email);
    } else {
      console.log(`Fallback to apiService`);
        this.apiService.requestOtp(email).subscribe(
        response => {
          this.message = 'OTP sent successfully';
          this.showOtpForm = true;
          this.verifyOtp = true;
          this.startResendTimer();
        },
        error => {
          this.message = 'Error: ' + error.message;
          this.verifyOtp = false;
        }
      );
    }
    // this.socketService.disconnect();
  }




  onValidateOtp(): void {
    const email = this.form.get('Email')?.value;
    const otp = this.form.get('OTP')?.value;
    const passwordControl = this.form.get('NewPassword');
    const password = passwordControl?.value;

    // Mark password field as touched to show validation errors
    passwordControl?.markAsTouched();

    // Validate password before proceeding
    if (passwordControl?.invalid) {
      this.message = 'Please enter a valid password that meets all requirements.';
      alert(this.message);
      return;
    }

    this.apiService.validateOtp(email, otp).subscribe(
      response => {
        this.message = 'OTP validated successfully';
        this.token = response.token;
        this.apiService.updatePassword(email, password).subscribe(
          response => {
            alert('password updated successfully');
            this.showOtpForm = false;
            this.verifyOtp = false;
          },
          error => {
            const errorMsg = error.error?.error || error.error?.message || error.message || 'An error occurred';
            this.message = errorMsg;
            alert(this.message);
          }
        )
        // this.cookieService.set('token', this.token, 86400);
        // this.data  = response.user;
        // // Convert the user object to a JSON string
        // const userData = response.user; 
        // const userDataJson = JSON.stringify(userData);
        // this.cookieService.set('userData', userDataJson, 86400);
        // this.cookieService.set('isLoggedIn', "true", 86400);
        // // console.log(this.cookieService.get('userData'));
        // alert(this.message);
        // this.router.navigate(['/home']);
      },
      error => {
        this.message = 'Error: ' + error.message;
        alert(this.message);
      }
    );
  }

  onResendOtp(): void {
    const email = this.form.get('Email')?.value;

    this.apiService.reSendOtp(email).subscribe(
      response => {
        this.message = 'OTP resent successfully';
        this.startResendTimer();
      },
      error => {
        this.message = 'Error: ' + error.message;
      }
    );
  }

  submitForm(): void {
    this.loginSubmitted = true;
    // Validate only login controls
    const loginControls = ['Email', 'Password'];
    if (!this.areControlsValid(loginControls)) {
      return;
    }
    const email = this.form.get('Email')?.value;
    const password = this.form.get('Password')?.value;
    const purpose = 'authentication';

    this.apiService.login(email, password, purpose).subscribe(
      response => {
        const token = response.token || '';
        this.token = token;
        this.cookieService.set('token', token, 86400);
        
        // Handle both response.user and response.data.user for backward compatibility
        const userData = response.user || response.data?.user;
        if (userData) {
          this.data = userData;
          console.log("Setting user data in cookie:", userData);
          this.cookieService.set('userData', JSON.stringify(userData), 86400);
          this.cookieService.set('isLoggedIn', "true", 86400);
          console.log(this.data);
        } else {
          console.error("User data not found in response:", response);
        }
        
        alert(response.message);
        this.loginSubmitted = false;
        
        // Resume inactivity tracking after successful login
        this.inactivityService.resumeTracking();
        
        this.router.navigate(['/home']);
      },
      error => {
        console.log(error);
        this.message = `${error.error.message}`;
        alert(this.message);
        // alert("Error while logging in. Please check your credentials");
      }
    )
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      // Defer to (ngSubmit) handlers to avoid double-submit/duplicate alerts
      return;
    }
  }

  private startResendTimer(): void {
    this.canResendOtp = false;
    setTimeout(() => {
      this.canResendOtp = true;
    }, this.resendTimeoutDuration);
  }

// toggle between login and register forms
isRegister = false; // default = Login form
showPassword = false; // for registration form
showLoginPassword = false; // for login form
showResetPassword = false; // for password reset form

togglePasswordVisibility() {
  this.showPassword = !this.showPassword;
}

toggleLoginPasswordVisibility() {
  this.showLoginPassword = !this.showLoginPassword;
}

toggleResetPasswordVisibility() {
  this.showResetPassword = !this.showResetPassword;
}

onSubmit() {
  this.registerSubmitted = true;
  // Validate only register controls
  const registerControls = ['FirstName', 'LastName', 'Email', 'Password', 'Terms'];
  if (!this.areControlsValid(registerControls)) {
    return;
  }
  const formData = {
    first_name: this.form.get('FirstName')?.value,
    last_name: this.form.get('LastName')?.value,
    email: this.form.get('Email')?.value,
    password: this.form.get('Password')?.value,
    terms: this.form.get('Terms')?.value,
  };
  this.apiService.register(formData).subscribe(
    response => {
      alert(response.message || "Registered successfully!");
      this.isRegister = false;
      this.registerSubmitted = false;
    },
    error => {
      const msg:string = error.error.error;
      console.log(msg);
      if( msg.includes("Email already ") || msg.includes("Mobile number already ")){
        alert(msg.substring(16));
        this.toggleLogin();
      }else{
        alert(error.error.message || "Error registering user");
      }
    }
  );
  }
// onSubmit(): void {
//   if (this.form.invalid) {
//     alert("Please fill all required fields");
//     return;
//   }

//   const formData = {
//     firstName: this.form.get('FirstName')?.value,
//     lastName: this.form.get('LastName')?.value,
//     email: this.form.get('Email')?.value,
//     password: this.form.get('Password')?.value,
//     terms: this.form.get('Terms')?.value,
//   };

//   this.apiService.register(formData).subscribe(
//     response => {
//       alert(response.message || "Registered successfully!");
//       // Optionally store token & userData just like login
//       this.cookieService.set('token', response.token, 86400);
//       this.cookieService.set('userData', JSON.stringify(response.user), 86400);
//       this.cookieService.set('isLoggedIn', "true", 86400);

//       this.router.navigate(['/home']); // redirect after signup
//     },
//     error => {
//       this.message = `${error.error}`;
//       alert(this.message);
//     }
//   );
// }

  toggleForm() {
    this.isRegister = !this.isRegister;
    this.resetValidationState();
  }
  toggleLogin() {
    this.isRegister = false;
    this.resetValidationState();
  }
  toggleRegister() {
    this.isRegister = true;
    this.resetValidationState();
  }
  toggleForgotPassword() {
    // Logic to toggle forgot password view
    console.log('Forgot Password clicked');
    
  }

  goBack(): void {
    this.router.navigate(['/project-explanation']);
  }

  private resetValidationState(): void {
    this.loginSubmitted = false;
    this.registerSubmitted = false;
  }

}



